import {isArray} from '@shared/helpers/lang'

import {STI_INFO} from '@web/core/constants'
import {isPC} from '@web/helpers/userAgent'
import {
    uiEventLoggerCreator,
    PageViewEvent,
    createPageViewTargetMap,
    pageViewAction,
    PageViewLoggers,
    uiEventAction,
} from '@web/middlewares/uiLogging'

import {resultNClicksMap} from '../../../constants/nClicks'
import {CheckoutRootState as RootState} from '../../../interfaces'

const pageViewLoggers: PageViewLoggers = ['lcs']

const uiEventLogger = uiEventLoggerCreator<RootState>({
    nClicksTargetMap: resultNClicksMap,
    convertNClicksCode: ({value}) => {
        return isArray(value) ? (isPC ? value[1] : value[0]) : value
    },
    pageViewTargetMap: createPageViewTargetMap([
        [PageViewEvent.ORDER, pageViewLoggers],
        [PageViewEvent.BRANCH, pageViewLoggers],
        [PageViewEvent.GIFTING, pageViewLoggers],
    ]),
    pageViewLogger: {
        getLcs: ({target}) => {
            return {
                sti: (function () {
                    if (target === PageViewEvent.BRANCH) {
                        return isPC ? STI_INFO.ORDER.PC_BRANCH : STI_INFO.ORDER.MO_BRANCH
                    } else if (target === PageViewEvent.GIFTING) {
                        return isPC ? STI_INFO.ORDER.PC_GIFTING : STI_INFO.ORDER.MO_GIFTING
                    } else if (target === PageViewEvent.WAITING) {
                        return isPC ? STI_INFO.ORDER.PC_WAITING : STI_INFO.ORDER.MO_WAITING
                    }
                    return isPC ? STI_INFO.ORDER.PC : STI_INFO.ORDER.MO
                })(),
            }
        },
    },
})

export const uiEventActions = [uiEventAction.type, pageViewAction.type]

export default uiEventLogger
